import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import SettingsIcon from '@/assets/settings-icon';
import LeftCard from '@/views/home_view/components/left-card/LeftCard';
import RightCard from '@/views/home_view/components/right-card/RightCard';

import useConfigStore from '@/store/configStore';
import useAppStore from '@/store/app.store';

import { appRoutes } from '@/config/appRoutes';
import { ROLES } from '@/constants/roles';

interface SettingsCardProps {
  variant?: 'left' | 'right';
}

export default function SettingsCard({ variant = 'left' }: Readonly<SettingsCardProps>) {
  const navigate = useNavigate();
  const environmentSettings = useConfigStore((state) => state.environmentSettings);
  const user = useAppStore((state) => state.user);

  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    navigate(`${environmentSettings?.BASE_PATH ?? ''}${appRoutes.SETTINGS}`);
  }, [navigate, environmentSettings]);

  const disabled = useMemo(() => user?.role !== ROLES.MOEVE_ADMIN && user?.role !== ROLES.MANAGER, [user]);

  if (variant === 'right') {
    return (
      <RightCard
        title={t('home.settingsCard.title')}
        description={t('home.settingsCard.description')}
        backgroundColor="#F3BDFF"
        textColor="var(--palette-text-primary)"
        iconColor="var(--palette-text-primary)"
        Icon={SettingsIcon}
        disabled={disabled}
        onClick={handleClick}
      />
    );
  }

  return (
    <LeftCard
      title={t('home.settingsCard.title')}
      description={t('home.settingsCard.description')}
      backgroundColor="#F3BDFF"
      textColor="var(--palette-text-primary)"
      iconColor="var(--palette-text-primary)"
      Icon={SettingsIcon}
      disabled={disabled}
      onClick={handleClick}
    />
  );
}
